import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { noticeForError } from '@backrs_ui/grow-ui/src/components/InstitutionWrite/noticeForError';
import { WriteDialog } from '@backrs_ui/grow-ui/src/components/InstitutionWrite/WriteDialog';
import { isSubmittableCode, randomCode } from '@backrs_ui/grow-ui/src/redux/institutionAdmin';

import { Box, Button, Typography } from '@mui/material';

import { CodeField } from './CodeField';

const { createCodeDialog: strings } = appStrings.modules.rostersAdmin;

const FORM_ID = 'rosters-admin-create-code-form';

type CreateCodeDialogProps = Readonly<{
  open: boolean;
  onClose: () => void;
  /** The line the code is for and the roster it sits in, both named in the title. */
  subjectName: string;
  rosterName: string;
  code: string;
  onCodeChange: (next: string) => void;
  isSubmitting: boolean;
  isWriteInFlight: boolean;
  isError: boolean;
  errorMessage?: string | null;
  onSubmit: () => void;
}>;

export const CreateCodeDialog = ({
  open,
  onClose,
  subjectName,
  rosterName,
  code,
  onCodeChange,
  isSubmitting,
  isWriteInFlight,
  isError,
  errorMessage,
  onSubmit,
}: CreateCodeDialogProps) => {
  const canSubmit = isSubmittableCode(code) && !isSubmitting && !isWriteInFlight;

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    if (canSubmit) onSubmit();
  };

  return (
    <WriteDialog
      id="rosters-admin-create-code-dialog"
      open={open}
      onClose={onClose}
      title={strings.title(subjectName)}
      subtitle={strings.context(rosterName)}
      footer={
        <>
          <Button
            id="rosters-admin-create-code-generate"
            hierarchy="Secondary gray"
            size="md"
            type="button"
            onClick={() => onCodeChange(randomCode())}
          >
            {strings.generate}
          </Button>
          <Button
            id="rosters-admin-create-code-dialog-submit"
            hierarchy="Primary"
            size="md"
            form={FORM_ID}
            type="submit"
            disabled={!canSubmit}
          >
            {isSubmitting ? strings.submitting : strings.submit}
          </Button>
        </>
      }
    >
      <Box
        component="form"
        id={FORM_ID}
        onSubmit={handleSubmit}
        aria-label={strings.title(subjectName)}
      >
        <CodeField
          idPrefix="rosters-admin-create-code"
          code={code}
          onCodeChange={onCodeChange}
          isError={isError}
        />
      </Box>
      {isError ? (
        <Typography id="rosters-admin-create-code-error" variant="text-sm-regular" role="alert">
          {noticeForError(errorMessage, strings.failed)}
        </Typography>
      ) : null}
    </WriteDialog>
  );
};
